import { MINIMUM_INPUT_LENGTH, MINIMUM_QUERY_LENGTH } from '../constants'
import {
  resetIsCompleteTickIcon,
  setMinimumDigitsInputHelperText,
} from '../helpers'
import { fetchBusinessNumber } from './fetch-business-number'

/**
 * This function performs an API call to the ABN Lookup using a Text Based Search
 */
export const NumberBasedSearch = (query, elements) => {
  const { ABNInput, ABNTextSearchInput, next: navigationNextButton } = elements
  const helperText = document.getElementById(`helper-text`)

  const isGreaterThanQueryMinimum = query && query.length > MINIMUM_QUERY_LENGTH
  const isLessThanQueryMinimum = query && query.length < MINIMUM_QUERY_LENGTH
  const hasPassedMinimumInputLength =
    query && query.length >= MINIMUM_INPUT_LENGTH
  const isLessThanInputMinimumAndGreaterThanQueryMinimum =
    query &&
    query.length < MINIMUM_INPUT_LENGTH &&
    query.length > MINIMUM_QUERY_LENGTH

  if (isGreaterThanQueryMinimum) {
    resetIsCompleteTickIcon(ABNInput, ABNTextSearchInput)
  }

  if (isLessThanInputMinimumAndGreaterThanQueryMinimum) {
    const numbersRemaining = MINIMUM_INPUT_LENGTH - query.length
    helperText.innerHTML = setMinimumDigitsInputHelperText(numbersRemaining)
  } else if (isLessThanQueryMinimum) {
    helperText.innerHTML = ``
  } else if (hasPassedMinimumInputLength) {
    helperText.innerHTML = ``
    fetchBusinessNumber(query, elements, `number`)
  } else {
    navigationNextButton.classList.add(`disabled`)
  }
}
